import React from 'react';
import { Link } from 'react-router';

import { FormattedPlural } from 'react-intl';

import { ListItem } from 'material-ui/List';

import ContextIconMenu from '../Common/ContextIconMenu';
import EditIcon from 'material-ui/svg-icons/editor/mode-edit';
import FilterIcon from 'material-ui/svg-icons/content/filter-list';

import { statusColours } from '../../constants/ColourConstants';

import FilterActions from '../../actions/FilterActionCreator';

import ROLES from '../../constants/Roles';

const style = {
    listItem: {
        padding: '2px',
    },
    icon: {
        height: '32px',
        width: '32px',
    }
};

const getActions = (row) => [
    {
        link: `/dashboard/filter/${row.id}/edit`,
        label: 'Edit',
        icon: <EditIcon />,
        condition: {
            roles: [ROLES.ADMIN]
        }
    },
    {
        type: 'deleteDialog',
        dialogType: 'menu',
        value: row.id,
        title: 'Delete filter',
        deleteAction: FilterActions.delete,
        message: (<span>Are you sure to delete the filter  "{row.name}" ?</span>),
        condition: {
            roles: [ROLES.ADMIN]
        }
    }
];

const FilterListItem = ({data}) => {
    const infoLink = `/dashboard/filter/${data.id}`;
    return (
        <ListItem
            style={style.listItem}
            leftAvatar={
                <Link to={infoLink}>
                <FilterIcon style={style.icon} color={statusColours.primary} />
                </Link>
                }
            primaryText={<Link to={infoLink} className="primaryText">{data.name}</Link>}
            secondaryText={
                <Link to={infoLink} className="secondaryText">
                    <em>{(data.description || 'Filter')}</em><br/>
                    {data.count}&nbsp;<FormattedPlural value={data.count || 0} one='match' other='matches' />
                </Link>
            }
            secondaryTextLines={2}
            rightIcon={<ContextIconMenu actions={getActions(data)} data={data} />}
        />
    )
};

export default FilterListItem;
